// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-preview[data-v-a7a2a8b6]{display:flex;flex-direction:column;gap:16px}.article-preview__image[data-v-a7a2a8b6]{flex:1;min-height:153px;border-radius:8px;overflow:hidden}.article-preview__title[data-v-a7a2a8b6]{color:#fff;font-size:16px;font-style:normal;font-weight:900;line-height:24px;letter-spacing:.24px;margin:0;height:48px;display:-webkit-box;line-clamp:2;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}", ""]);
// Exports
module.exports = exports;
